import { render, staticRenderFns } from "./SuperSyndicatePortfolio.vue?vue&type=template&id=0c65b501&scoped=true&"
import script from "./SuperSyndicatePortfolio.vue?vue&type=script&lang=js&"
export * from "./SuperSyndicatePortfolio.vue?vue&type=script&lang=js&"
import style0 from "./Styles/SuperSyndicate.css?vue&type=style&index=0&id=0c65b501&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c65b501",
  null
  
)

export default component.exports